function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3679 33.724C22.3052 33.724 24.6864 31.3428 24.6864 28.4055C24.6864 25.4681 22.3052 23.0869 19.3679 23.0869C16.4305 23.0869 14.0493 25.4681 14.0493 28.4055C14.0493 31.3428 16.4305 33.724 19.3679 33.724Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.9035 39.2837L53.3568 42.3509L56.424 43.8043L53.3568 45.2576L51.9035 48.3248L50.4501 45.2576L47.3829 43.8043L50.4501 42.3509L51.9035 39.2837ZM51.9035 37.9463C51.3863 37.9463 50.9182 38.245 50.6953 38.7131L49.447 41.3523L46.8078 42.6006C46.3397 42.8235 46.041 43.2916 46.041 43.8087C46.041 44.3259 46.3397 44.794 46.8078 45.0169L49.447 46.2652L50.6953 48.9044C50.9182 49.3725 51.3863 49.6712 51.9035 49.6712C52.4206 49.6712 52.8887 49.3725 53.1116 48.9044L54.3599 46.2652L56.9991 45.0169C57.4672 44.794 57.7659 44.3259 57.7659 43.8087C57.7659 43.2916 57.4672 42.8235 56.9991 42.6006L54.3599 41.3523L53.1116 38.7131C52.8887 38.245 52.4206 37.9463 51.9035 37.9463Z",
  fill: "#4C2C89"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2537 6.44484L42.0462 8.71402L37.2537 10.9832L34.9845 15.7757L32.7153 10.9832L27.9229 8.71402L32.7153 6.44484L34.9845 1.65234L37.2537 6.44484Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0478 76.1567V56.4918C25.0478 56.4918 27.103 68.9746 12.4 69.4516C12.4 69.4516 8.47242 69.4338 8.34313 66.5316C8.20939 63.6293 11.3613 63.5268 11.3613 63.5268C11.3613 63.5268 18.4988 64.3471 18.4497 56.7816C18.4141 51.2357 17.7765 45.2306 17.7765 45.2306C17.7765 45.2306 14.6692 44.972 8.49025 49.3143C7.40693 50.0766 4.40215 52.1273 2.73926 50.7542C-0.256602 48.28 4.25503 44.5351 5.63259 43.4117C9.3908 40.3445 14.5711 38.6504 18.2134 37.3085C23.7059 35.2845 27.9232 33.0421 34.2895 25.811C36.6032 23.1807 38.5782 22.0216 39.9736 23.0826C41.3779 24.1481 42.0422 26.4619 38.8858 30.7996C36.63 33.9025 35.4129 35.0616 30.1345 39.279C30.1345 39.279 33.3934 55.092 30.3262 76.1522",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.31885 76.1564H37.7312L36.6746 67.8197H51.7564L50.4547 58.9971H73.1555",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M64.5818 4.49243L67.9388 10.9032L75.2278 11.9018C76.6856 12.1025 77.2518 13.9125 76.1685 14.9066L70.9659 19.6857L72.2186 26.5557C72.4727 27.9645 71.0149 29.0612 69.7354 28.4281L63.0438 25.1113L56.3521 28.4281C55.0682 29.0612 53.6104 27.9645 53.8689 26.5557L55.1217 19.6857L49.919 14.9066C48.8357 13.9125 49.4019 12.1025 50.8597 11.9018L58.1487 10.9032L61.5057 4.49243C62.1477 3.24862 63.9265 3.24862 64.5818 4.49243Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2754 62.2783H73.1559",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7563 67.8203L52.1441 70.9499H37.0088",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function Svg6Franqueado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Franqueado);
export default __webpack_public_path__ + "static/media/6-franqueado.b8f1d88f9676b6f8bb74451823a71368.svg";
export { ForwardRef as ReactComponent };